import { FETCH_PROPERTY_TYPE_FRONT } from "../types";

export const propertyTypeFrontReducer = (
  state = { isLoading: true, data: [] },
  action: { type: any; payload: any }
) => {
  switch (action.type) {
    case FETCH_PROPERTY_TYPE_FRONT:
      return {
        isLoading: false,
        data: action.payload,
      };
    default:
      return state;
  }
};
